// California County FIPS Code to County Name Mapping
// FIPS codes are 3-digit codes where:
// - 001 = Alameda
// - 013 = Contra Costa
// - etc.
// This mapping is used to verify correct county assignment when matching tracts

export const COUNTY_FIPS_TO_NAME: Record<string, string> = {
  '001': 'ALAMEDA',
  '003': 'ALPINE',
  '005': 'AMADOR',
  '007': 'BUTTE',
  '009': 'CALAVERAS',
  '011': 'COLUSA',
  '013': 'CONTRA COSTA',
  '015': 'DEL NORTE',
  '017': 'EL DORADO',
  '019': 'FRESNO',
  '021': 'GLENN',
  '023': 'HUMBOLDT',
  '025': 'IMPERIAL',
  '027': 'INYO',
  '029': 'KERN',
  '031': 'KINGS',
  '033': 'LAKE',
  '035': 'LASSEN',
  '037': 'LOS ANGELES',
  '039': 'MADERA',
  '041': 'MARIN',
  '043': 'MARIPOSA',
  '045': 'MENDOCINO',
  '047': 'MERCED',
  '049': 'MODOC',
  '051': 'MONO',
  '053': 'MONTEREY',
  '055': 'NAPA',
  '057': 'NEVADA',
  '059': 'ORANGE',
  '061': 'PLACER',
  '063': 'PLUMAS',
  '065': 'RIVERSIDE',
  '067': 'SACRAMENTO',
  '069': 'SAN BENITO',
  '071': 'SAN BERNARDINO',
  '073': 'SAN DIEGO',
  '075': 'SAN FRANCISCO',
  '077': 'SAN JOAQUIN',
  '079': 'SAN LUIS OBISPO',
  '081': 'SAN MATEO',
  '083': 'SANTA BARBARA',
  '085': 'SANTA CLARA',
  '087': 'SANTA CRUZ',
  '089': 'SHASTA',
  '091': 'SIERRA',
  '093': 'SISKIYOU',
  '095': 'SOLANO',
  '097': 'SONOMA',
  '099': 'STANISLAUS',
  '101': 'SUTTER',
  '103': 'TEHAMA',
  '105': 'TRINITY',
  '107': 'TULARE',
  '109': 'TUOLUMNE',
  '111': 'VENTURA',
  '113': 'YOLO',
  '115': 'YUBA'
};

// Helper function to get county name from GEOID
export function getCountyFromGeoid(geoid: string): string | null {
  const geoidStr = geoid.padStart(11, '0'); // Ensure 11 digits with leading zeros
  const countyCode = geoidStr.substring(2, 5); // Extract county FIPS code (positions 2-4)
  return COUNTY_FIPS_TO_NAME[countyCode] || null;
}

/** Normalize census tract ids from GeoJSON GEOID or ev_by_tract_2023.tract for reliable joins. */
export function normalizeCensusTractGeoid(geoid: string | number | null | undefined): string | null {
  if (geoid === null || geoid === undefined) return null;
  const raw = String(geoid).trim();
  if (!raw || raw === 'NaN') return null;
  const digits = raw.replace(/\D/g, '');
  if (!digits) return null;
  if (digits.length >= 11) return digits.slice(0, 11);
  return digits.padStart(11, '0');
}

